import { useDispatch, useSelector } from "react-redux";

import {
  selectCancelRequestData,
  selectReasonCancelRequest,
} from "modules/DeclareLeave/redux/selector";
import { ConfirmModal } from "components/common/ConfirmModal";
import { formReqLeaveReset } from "modules/DeclareLeave/redux/formReqLeave";
import { ContentModalCancelRequest } from "./style";
import { ReactComponent as IconWarning } from "assets/svg/20-warning.svg";

import AutoResizeTextarea from "components/common/AutoResizeTextarea";
import { Box, Divider, Typography } from "@mui/material";

import { deleteRequestStart } from "modules/DeclareLeave/redux/deleteRequest";
import { resetRequestLeaveDetail } from "modules/DeclareLeave/redux/getRequestLeaveDetail";
import {
  cancelRequestStart,
  setCancelRequestData,
  setReasonData,
} from "modules/DeclareLeave/redux/cancelRequest";
import pxToRem from "theme/base/pxToRem";
import { useDialog } from "helper/customHook";
import { DIALOG } from "helper/enum/dialogEnum";
import { declareLeaveURL } from "../..";
import { SCREEN } from "helper/roleChecker/Screens";

export const ConfirmModalDelete = () => {
  const dispatch = useDispatch();
  const approveDialog = useDialog(DIALOG.MODAL_CONFIRM);

  const idCancelRequestData = useSelector(selectCancelRequestData);
  const reasonCancelRequest = useSelector(selectReasonCancelRequest);

  const contentModalCancelRequest = () => {
    return (
      <ContentModalCancelRequest>
        <Box className="textContent">
          <Box className="iconWrapper">
            <IconWarning />
          </Box>
          <Typography
            sx={(theme) => ({
              fontSize: pxToRem(14),
              color: theme.palette.text.textPrimary,
              textAlign: "center",
            })}
          >
            Đơn này của bạn đã được Duyệt, bạn có chắc muốn hủy không?
          </Typography>
        </Box>
        <Divider style={{ width: "100%" }} />
        <Box display={"flex"} gap={0.5} className="reason">
          <Typography fontSize={14}>Nhập lý do từ chối</Typography>
          <Typography
            fontSize={14}
            sx={(theme) => ({ color: theme.palette.text.textSecondary })}
          >
            {`(Bắt buộc)`}
          </Typography>
        </Box>
        <AutoResizeTextarea
          placeholder="Nhập ghi chú của bạn"
          onChange={handleOnChange}
          sx={{ width: pxToRem(380) }}
          value={reasonCancelRequest}
        />
      </ContentModalCancelRequest>
    );
  };
  const handleOnChange = (e: string) => {
    dispatch(setReasonData(e));
  };
  const deleteRequest = () => {
    approveDialog.close();
    dispatch(formReqLeaveReset());
    dispatch(resetRequestLeaveDetail());
    dispatch(
      deleteRequestStart({
        tab: declareLeaveURL.leave,
        screenCode: SCREEN.IP_016,
      })
    );
  };

  const cancelRequest = () => {
    dispatch(cancelRequestStart({ tab: "leave", screenCode: SCREEN.IP_016 }));
    handleClose();
  };

  const handleClose = () => {
    approveDialog.close();
    dispatch(setCancelRequestData(null));
    dispatch(setReasonData(""));
  };
  return (
    <ConfirmModal
      title={
        idCancelRequestData ? "Xác nhận hủy đơn" : "Bạn có muốn xóa đơn này"
      }
      styleTitle={{
        width: idCancelRequestData ? "100%" : pxToRem(300),
      }}
      buttonApprove={idCancelRequestData ? "Hủy đơn" : "Xóa đơn"}
      buttonReject={idCancelRequestData ? "Hủy bỏ" : "Hủy"}
      content={idCancelRequestData ? contentModalCancelRequest() : null}
      styleContent={{
        borderBottom: idCancelRequestData ? "1px solid #E6E6E6" : "none",
      }}
      buttonApproveProps={{
        color: "error",
        disabled: !reasonCancelRequest.trim() && idCancelRequestData,
      }}
      buttonRejectProps={{
        variant: "blur",
        sx: {
          backgroundColor: "#E6E6E6",
          color: "#000000",
        },
      }}
      onApprove={idCancelRequestData ? cancelRequest : deleteRequest}
      onReject={handleClose}
    />
  );
};
